/**
 * 灰度配置 Key 常量
 * 统一管理所有灰度配置的 key，避免硬编码
 */

/**
 * 地址定位不准功能灰度配置
 * 支持JSON单维度格式：{"dspIds": [1,2,3]}
 * 支持多维度格式：{"driverIds": [16879], "dspIds": [250, 277]}
 */
export const GRAY_CONFIG_ADDRESS_COORDINATE_FEEDBACK = 'address.coordinate_feedback.gray_config';

/**
 * 导航地址标准化功能灰度配置
 * 支持JSON单维度格式：{"warehouseIds": [1,2,3]}
 * 支持多维度格式：{"warehouseIds": [1,2,3], "dspIds": [250, 277]}
 */
export const GRAY_CONFIG_NAVIGATION_ADDRESS_ANALYZE = 'navigation.address_analyze.gray_config';

/**
 * TMS 司机端拍照水印禁用开关
 * 启用后，TMS 司机上传照片时不添加水印，直接上传原图
 */
export const GRAY_CONFIG_TMS_DRIVER_PHOTO_WATERMARK_DISABLED = 'tms.driver.photo.watermark.disabled';

/**
 * TMS 司机端水印「Android 原生定位」降级开关
 * 启用后，Android App >= 9.1.0 也强制退回旧逻辑：navigator.geolocation + Mapbox 反解。
 * 用于 Android 原生定位（getNativeLocation）线上效果不好时的应急回退，只影响 Android，
 * 不影响 iOS（iOS 用下面的独立开关）。
 */
export const GRAY_CONFIG_TMS_DRIVER_WATERMARK_ANDROID_NATIVE_LOCATION_DISABLED = 'tms.driver.watermark.native_location.android_disabled';

/**
 * TMS 司机端水印「iOS 原生定位」降级开关
 * 启用后，iOS App >= 9.1.0 也强制退回 9.1.0 之前的行为——不打水印。
 * iOS 没有可用的历史 Mapbox 路径（旧版本 navigator.geolocation 在 iOS 上会卡死拿不到坐标），
 * 所以这里退回的是「关闭水印」而非「切回 Mapbox」，与 Android 开关的退回效果不同。
 * 只影响 iOS，不影响 Android（Android 用上面的独立开关）。
 */
export const GRAY_CONFIG_TMS_DRIVER_WATERMARK_IOS_NATIVE_LOCATION_DISABLED = 'tms.driver.watermark.native_location.ios_disabled';

